import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_URL } from "../../config";

export const terminationApi = createApi({
  reducerPath: "terminationApi",
  tagTypes: ["Termination"],
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTerminationTypes: builder.query({
      query: () => ({
        url: "/termination/portal/termination-types",
        method: "GET",
      }),
      providesTags: ["Termination"],
    }),
    terminateEmployee: builder.mutation({
      query: (payload) => ({
        url: "/termination/portal/terminate-employee",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Termination"],
    }),
    submitTwoWeekNotice: builder.mutation({
      query: () => ({
        url: "/termination/portal/submit-notice",
        method: "POST",
      }),
      invalidatesTags: ["Termination"],
    }),
  }),
});

export const { useGetTerminationTypesQuery, useTerminateEmployeeMutation, useSubmitTwoWeekNoticeMutation } = terminationApi;